export default __webpack_public_path__ + "static/media/Shopping-Bag-icon.5a567cf2.webp";